import * as React from 'react';
import { SvgIcon } from '../svg-icon';
import { MerchantCardPreference } from '../../webgiving-generated';
import { Text } from '../text';
import * as styles from './payment-method-selector.less';
import addIcon from '../../assets/svg/add.svg';

interface IAddPaymentMethodProps {
	acceptanceTestTargetId: string;
	cardPreference?: MerchantCardPreference | null;
	supportsAch: boolean;
	supportsCard: boolean;
	onClick: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

export class AddPaymentMethod extends React.Component<IAddPaymentMethodProps, {}> {
	render() {
		return (
			<div className={`col-sm-6 ${styles.method}`}>
				<a href="#"
					className={`${styles.selector} ${styles.newPaymentMethod}`}
					data-pp-at-target={this.props.acceptanceTestTargetId}
					onClick={this.props.onClick}
				>
					<SvgIcon svg={addIcon} className={styles.addIcon} />
					<h3 className={styles.heading}><Text>Add new payment method</Text></h3>
					<p className={styles.text}><Text>{this.getDescription()}</Text></p>
				</a>
			</div>
		);
	}

	private getDescription(): string {
		const {cardPreference, supportsAch, supportsCard} = this.props;
		let description: string = '';

		if(supportsAch) {
			if(supportsCard) {
				switch (cardPreference) {
					case MerchantCardPreference.AnyCard:
						description = 'Supported payment methods include credit cards, debit cards and bank accounts.';
						break;
					case MerchantCardPreference.DebitPreferred:
						description = 'Preferred payment methods include debit cards and bank accounts but credit cards are also accepted.';
						break;
					case MerchantCardPreference.DebitOnly:
						description = 'Supported payment methods include debit cards and bank accounts.';
						break;
				}
			} else {
				description = 'Supported payment method is bank account only.';
			}
		} else {
			switch (cardPreference) {
				case MerchantCardPreference.AnyCard:
					description = 'Supported payment methods include credit cards and debit cards.';
					break;
				case MerchantCardPreference.DebitPreferred:
					description = `Preferred payment method is debit card but credit cards are also accepted.`;
					break;
				case MerchantCardPreference.DebitOnly:
					description = `Supported payment method is debit card only.`;
					break;
			}
		}
		return description;

	}
}
